import * as z from 'zod';

import { statusFormSchema } from '@/_schemas/status-input';

import { billingSystemQuerySchema } from './billing-system-query-schema';

export const billingSystemFormSchema = billingSystemQuerySchema
  .omit({ name: true, status: true, clients_count: true })
  .extend({
    name: z.string().min(3),
    status: statusFormSchema,
  });

export type BillingSystemFormSchema = z.infer<typeof billingSystemFormSchema>;
